<section class="subfieldValue" [class.pointCF__input--focus]="focused">
  <div class="subfield__inner">
    <section
      ppTooltip
      [ppTitle]="ppUnitTooltip"
      class="customFieldNumeric__unitWrapper"
      [class.customFieldNumeric__unitWrapper--hidden]="!ppUnit"
    >
      @if (ppUnit && !ppCanEdit) {
        <span data-test="custom-field-subfield-number-input-unit" class="customFieldNumeric__unit">
          {{ ppUnit }}
        </span>
      }

      @if (ppCanEdit) {
        <pp-icon
          ppTooltip
          [ppTitle]="'calculation_enabled' | ppTranslate"
          [ppSrc]="EIconPath.ICON_MISC_CALCULATOR_24"
          ppColor="grey-300"
          ppClass="setSize24"
          class="subfield__calculator__icon"
          data-test="cf-cost-calculator-icon"
        />
      }
    </section>

    @if (ppCanEdit && !ppIsLocked) {
      <input
        preventPointSwitching
        [ppAutonumeric]="autonumericOptions"
        #subfieldValue
        class="subfield__value"
        [class.subfield__value--noUnit]="!ppUnit"
        [(ngModel)]="ppValue"
        (ngModelChange)="onValueChange($event)"
        [placeholder]="placeholder"
        (ppFormatted)="updateField($event)"
        (focus)="onFocus()"
        (blur)="onBlur()"
        (keydown)="onKeyDown($event)"
        (keydown.enter)="blurInput($event)"
        data-test="custom-field-subfield-number-input"
      />
    } @else {
      <div [ppTitle]="ppIsLocked ? ('locked_by_admin' | ppTranslate) : null" ppTooltip>
        <input
          [ppAutonumeric]="autonumericOptions"
          [class.subfield__value--noUnit]="!ppUnit"
          #subfieldValue
          class="subfield__value"
          [(ngModel)]="ppValue"
          [placeholder]="placeholder"
          disabled
          readonly
          data-test="custom-field-subfield-number-locked"
        />
      </div>
    }
  </div>
</section>
